/* eslint vue/component-api-style: 0 */
import './bootstrap'
import '../css/app.css'

import '@fortawesome/fontawesome-pro/css/solid.min.css'
import '@fortawesome/fontawesome-pro/css/regular.min.css'
import '@fortawesome/fontawesome-pro/css/fontawesome.min.css'

import { createInertiaApp } from '@inertiajs/vue3'
import createInertiaAppProps from './app_config'

createInertiaApp(createInertiaAppProps(false))
